module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header', {
    attrs: {
      "seller": _vm.seller
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab border-1px"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/goods'
    }
  }, [_vm._v("\n        商品\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/ratings"
    }
  }, [_vm._v("\n        评论\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/seller"
    }
  }, [_vm._v("\n        商家\n      ")])], 1)]), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "seller": _vm.seller
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9885ae6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 57
// module chunks = 0